import PersonaRelatedFiles from "../../../../tags/persona-related-files.marko";

const/d=$global.data
const/isView=Boolean(d.file)

div.container--persona-search
  if=isView
    a.back-link href=`/tools/persona/${d.game}` -- ← Database Search
    header
      h1.persona-page-title -- ${d.displayName || d.file}
      p.subtitle -- ${d.gameTitle} dialogue
      p.file-path style="font-size: 0.8rem; color: var(--muted-foreground); overflow-wrap: anywhere;"
        -- File: 
        code -- ${d.file}
      if=d.summary
        p style="color: var(--muted-foreground); margin-top: 0.5rem;"
          -- Context:
          i -- ${d.summary}
    if=d.overview
      section.persona-overview aria-label="File overview"
        h2 -- Overview
        p -- ${d.overview}
    if=d.error
      div.message-card style="border-color: #ef4444; color: #ef4444;" -- ${d.error}
    div
      for|vm| of=d.messages
        div.message-card
          ,class={ highlighted: vm.is_highlight }
          ,id=(vm.is_highlight ? "highlight" : (vm.msg_id || ""))
          ,style=(vm.reply_context ? "margin-left: 1.5rem; margin-bottom: 0.5rem;" : "")
          if=vm.reply_context
            div.reply-context
              span
                -- Response to selection: 
                strong -- ${vm.reply_context}
          div.flex
            div.message-speaker -- ${vm.speaker || ""}
            div.message-key -- ${vm.msg_id || ""}
          div.message-content -- $!{vm.formatted_content}
          div.message-raw -- ${vm.raw_content}
      if=d.highlightId
        script
          -- document.getElementById('highlight')?.scrollIntoView({ block: 'center' });
    PersonaRelatedFiles related=d.related
  else
    a.back-link href="/tools/persona" -- ← Games
    header
      h1.persona-page-title data-text=d.gameTitle -- ${d.gameTitle}
      p.subtitle -- Search through in-game messages
      if=(d.game === "4g" || d.game === "4g-v2")
        p style="font-size: 0.85rem; opacity: 0.7; margin-top: 0.25rem;"
          -- Old v1 search is still accessible via
          a href="/tools/persona/4g-v1" -- /tools/persona/4g-v1
          -- .
      if=(d.game === "4g-v1")
        p style="font-size: 0.85rem; opacity: 0.7; margin-top: 0.25rem;"
          -- This is the legacy v1 search (deprecated). Try the new search at
          a href="/tools/persona/4g" -- /tools/persona/4g
          -- .
    let/isExtended=(d.game === "4g" || d.game === "4g-v2")
    form.search-form method="GET"
      label for="q" class="sr-only" style="position: absolute; width: 1px; height: 1px; padding: 0; margin: -1px; overflow: hidden; clip: rect(0, 0, 0, 0); white-space: nowrap; border-width: 0;" -- Search messages
      input id="q" type="text" name="q" class="search-input" placeholder="Search messages..." value=d.query autofocus autocomplete="off" required aria-describedby="q-help search-error"
      div#search-error.search-error-msg role="alert"
      button type="submit" class="btn btn-primary" -- Search
    if=d.error
      div.message-card style="border-color: #ef4444; color: #ef4444;" -- ${d.error}
    if=d.query
      div.results-count -- Found ${d.totalCount} results across ${d.fileCount ?? d.results.length} files
      if=d.results.length === 0
        div.empty-state -- No messages found matching your query.
      else
        for|group| of=d.results
          div.file-group
            a.file-header href=`/tools/persona/${d.game}/view?file=${encodeURIComponent(group.file_path)}&id=${group.messages[0].msg_id || ""}`
              -- ${group.file_path}
              if=group.summary
                p.file-summary -- &#8627; ${group.summary}
            div.thread-container
              for|msg| of=group.messages
                div.message-card
                  div.flex
                    div.message-speaker
                      if=msg.type === "sel"
                        span.type-badge -- Selection
                      -- ${msg.speaker || ""}
                    div.message-key -- ${msg.msg_id || ""}
                  div.message-content -- $!{msg.formatted_content}
                  div.message-raw -- ${msg.raw_content}
    else
      div.empty-state
        div.persona3-info-fun -- INFO
        div.search-guide id="q-help" style="text-align: left; display: inline-block; max-width: 520px; font-size: 0.9em; opacity: 0.8;"
          strong style="display: block; margin-bottom: 0.5rem;" -- Search Tips:
          ul style="list-style: none; padding: 0; line-height: 1.6;"
            li
              code -- word*
              --  — Prefix matching
            li
              code -- "exact phrase"
              --  — Phrase search
            li
              code -- A AND B
              --  — Messages containing both terms
            li
              code -- A OR B
              --  — Messages containing either term
            if=isExtended
              li style="margin-top: 0.5rem; padding-top: 0.5rem; border-top: 1px solid var(--border);"
                strong -- Extended filters
                --  (extended search only):
              li
                code -- file:battle_pack.bin
                --  — File name / path (substring)
              li
                code -- dungeon:105
                --  — Dungeon ID (H105 → 105)
              li
                code -- speaker:Teddie
                --  — Speaker name
              li
                code -- type:sel
                --  — Message type (msg / sel)
              li
                code -- ext:bvp
                --  — File extension
              li
                code -- proc:talk_yosuke
                --  — Flow procedure
              li
                code -- has_speaker:yes
                --  — Only rows with a known speaker
              li
                code -- unique:yes
                --  — Collapse duplicate messages
      p style="font-size: 0.85rem; opacity: 0.7; margin-top: 1rem; max-width: 520px;"
        -- Browse: 
        if=isExtended
          a href=`/tools/persona/${d.game}/quiz` -- Quiz Q&A
          --  · 
          a href=`/tools/persona/${d.game}/links` -- Social-Link guide
          --  · 
        a href=`/tools/persona/${d.game}/files` -- All files (${d.browseTotal})
        for|f| of=d.topFolders
          --  · 
          a href=`/tools/persona/${d.game}/files/${f.urlSegments.map(encodeURIComponent).join("/")}` -- ${f.name} (${f.fileCount})
    div.persona3-fun -- SEARCH
  footer style="margin-top: 3rem; font-size: 0.8rem; color: var(--muted-foreground); border-top: 1px solid var(--border); padding-top: 1rem;"
    p
      strong -- Font License Info:
      --  Agane font was used for dialogues, made by
      a href="https://danieledemarco.com/" -- Danilo De Marco
      -- .
